import axios from 'axios';
import toast from 'react-hot-toast';

export const apiClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.response.use(
  (response) => {
    // Automatically show toast if a success message is present in standard response
    if (response.data && response.data.message && response.config.method !== 'get' && !(response.config as any).suppressToast) {
      toast.success(response.data.message);
    }
    return response.data; // Unwrap the data directly for easier consumption
  },
  (error) => {
    let message = 'An unexpected error occurred';

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (error.response.data && error.response.data.message) {
        message = error.response.data.message;
      }

      // Handle Unauthorized explicitly
      if (error.response.status === 401 && typeof window !== 'undefined') {
        if (!window.location.pathname.includes('/admin/login')) {
          window.location.href = '/admin/login';
        }
      }
      // Convert technical mongoose validation errors to user-friendly language
      if (typeof message === 'string') {
        if (message.includes("Path `category` is required")) {
          message = "Please select a category";
        } else if (message.includes("Path `")) {
          message = message.replace(/.*Path `([^`]+)` is required.*/, "Please provide a value for $1.");
        } else if (message.includes("Validation Error") || message.includes("validation failed")) {
          message = "Please check your inputs and try again.";
        }
      }
    } else if (error.request) {
      // The request was made but no response was received
      message = 'Network error or server is unreachable. Please check your connection.';
    } else {
      // Something happened in setting up the request that triggered an Error
      message = error.message;
    }

    toast.error(message);
    return Promise.reject(error);
  }
);
